import {DesignDto, MemberDto} from "../generated/dashboard-client";
import {DESIGN_IN_USE_SECONDS} from "../util/constants";

export function isInUse(d: DesignDto, member: MemberDto) {
  if (!d.inUseLastPingAt || !member.id) return false;
  return member.internalId !== d.inUseMemberId && (new Date().getTime() - d.inUseLastPingAt) < DESIGN_IN_USE_SECONDS * 1000;
}